// validateAuth
export const validateLogin = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "Email Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.password) {
    errors.password = "Password Required";
  }

  return errors;
};

export const validateAuth = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "Email Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.password) {
    errors.password = "Password Required";
  }

  if (!values.username) {
    errors.username = "Username Required";
  }
  if (!values.phone) {
    errors.phone = "Phone Required";
  }

  return errors;
};

export const validateForgotPassword = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "Email Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  return errors;
};

//  validate update users
export const validateUpdateUser = (values) => {
  let errors = {};
  if (!values.email) {
    errors.email = "Email Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.username) {
    errors.username = "Username Required";
  }
  if (!values.phone) {
    errors.phone = "Phone Required";
  }
  if (!values.password) {
    errors.password = "Password Required";
  }
  if (!values.initial_balance) {
    errors.initial_balance = "Balance Required";
  }

  return errors;
};

// validate album
export const validateAlbum = (values) => {
  let errors = {};
  if (!values.name) {
    errors.name = "Name Required";
  }
  if (!values.description) {
    errors.description = "Description Required";
  }
  if (!values.price) {
    errors.price = "Price Required";
  }
  if (!values.artist) {
    errors.artist = "Artist Required";
  }
  if (!values.commision) {
    errors.commision = "Commision Required";
  }
  if (!values.image) {
    errors.image = "Image Required";
  }
  return errors;
};

export const validateEditPassword = (values) => {
  let errors = {};
  if (!values.password) {
    errors.password = "Password is required";
  }
  if (!values.newPassword) {
    errors.newPassword = "New Password Required";
  }
  if (!values.confirmPassword) {
    errors.confirmPassword = "Password confirmation is Required";
  }
  return errors;
};

// assign task
export const validateTask = (values) => {
  let errors = {};
  if (!values.numberOfTasks) {
    errors.numberOfTasks = "Number Of Tasks Required";
  }
  return errors;
};

export const validateCombo = (values) => {
  let errors = {};
  if (!values.commisionAmount) {
    errors.commisionAmount = "Commision  Required";
  }
  if (!values.freezingAmount) {
    errors.freezingAmount = "Freezing  Required";
  }
  return errors;
};
export const validateMedia = (values) => {
  let errors = {};
  if (!values.username) {
    errors.username = "Username  Required";
  }
  if (!values.phoneNumber) {
    errors.phoneNumber = "Phone  Required";
  }
  return errors;
};
